import React, { Component } from 'react';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import Link from '../../../../../components/ZUILib/Link';
import TextInput from '../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../components/ZUILib/InputButton';
import * as typeActions from '../../actions';
import commonUtil from '../../../../../utils/commonUtil';
import errorLables from '../../../../../utils/errors/LP_GR_error.json';

const { checkLoginValid } = typeActions;
export default class loginModal extends Component {
  constructor() {
    super();
    this.state = {
      reAuthenticateUserMessage: null,
    };
    this.loginForm = {
      login: '',
      password: '',
    };
  }
  onHandleShow = () => {
    this.password.setFocus();
  }
  handleLoginOnEnter = (e) => {
    if (e.key === 'Enter' && this.validate()) {
      this.loginConfirm();
    }
  }
  loginConfirm = () => {
    if (this.validate()) {
      checkLoginValid(this.loginForm).then((response) => {
        if (response.body.status.status === 'success') {
          this.props.handleHide();
          this.props.callSubmitTransference();
        } else if (response.body.status.errorMessage) {
          this.setState({ reAuthenticateUserMessage: response.body.status.errorMessage });
        }
      }).catch(() => {
      });
    }
  }
  isValueAvailable = (str) => {
    if (str && str.trim()) {
      return true;
    }
    return false;
  }
  validate = () => {
    const emailValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.invalid') },
    ];

    const passwordValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.invalid') },
    ];

    const isLoginValid = commonUtil.validateTextInput(emailValidationRules, this.login, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRules, this.password, null);


    if (isLoginValid && isPasswordValid) {
      this.loginForm.login = this.login.getValue();
      this.loginForm.password = this.password.getValue();
      return true;
    }
    return false;
  }
  clearErrorMessages = () => {
    this.setState({ reAuthenticateUserMessage: null });
  }
  render() {
    const loginConfirm = {
      name: 'Confirmar cierre',
      type: 'button',
      value: 'Confirmar cierre',
      autoFocus: false,
      onClickHandler: this.loginConfirm,
      style: 'btnPrimary size-Full',
    };
    const forgetPasswordLink = {
      text: 'Link Text',
      children: '¿Olvidaste tu contraseña?',
      areaLabel: 'abc',
      href: serverClientUtil.getLPFullURL() + '/users/forgotPassword?login=',
      tabindex: -1,
      cssClass: 'primaryColorLink',
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ reAuthenticateUserMessage: null }); },
    };
    return (
      <div>
        {this.state.reAuthenticateUserMessage ? <div className="row">
          <div className="alertError">
            <i className="icon-tache2" />
            <p>{this.state.reAuthenticateUserMessage}</p>
            <Link linkJSON={errorAncher} />
          </div>
        </div> : null}
        <small>{commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.label5')}</small>
        <br />
        <div className="errorMessage"><span className="text-red">* Campos obligatorios</span></div>
        <br />
        <form action="depositConfirmation.html">
          <div className="formBlock">
            <TextInput
              className="inputMaterial emailType"
              labelClassName="placeHolderMaterial"
              htmlId="example-optional-email"
              label="Correo Electrónico"
              required="true"
              star="*"
              value={this.props.userEmail}
              ref={login => this.login = login}
              disabled="disabled"
              onKeyPress={this.handleLoginOnEnter}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="example-optional-password"
              label="Contraseña"
              required="true"
              type="password"
              star="*"
              ref={password => this.password = password}
              onKeyPress={this.handleLoginOnEnter}
              disabled="disabled"
              value="**********"
            />
          </div>
          <InputButton buttonAttr={loginConfirm} />
          <Link linkJSON={forgetPasswordLink} href={forgetPasswordLink.href}>{forgetPasswordLink.children}</Link>
          {this.password && this.password.setValue('')}
          {this.password && this.password.setFocus()}
        </form>
      </div>
    );
  }
}
